"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardTile = exports.Border = exports.TileSize = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_core_1 = require("@volkswagen-onehub/components-core");
var TileSize;
(function (TileSize) {
    TileSize[TileSize["L"] = 2] = "L";
    TileSize[TileSize["S"] = 1] = "S";
})(TileSize = exports.TileSize || (exports.TileSize = {}));
exports.Border = styled_components_1.default.div `
    @media (min-width: ${components_core_1.Breakpoints.b560}px) {
        border: 1px solid ${props => props.theme.interaction.recipe250.default};
    }
    height:100%;
`;
exports.DashboardTile = props => {
    const tileAreaStyle = {
        overflow: 'hidden',
        gridRowEnd: `span ${props.size}`,
        gridColumnEnd: 'span 1'
    };
    if (props.border) {
        return React.createElement("div", { style: tileAreaStyle },
            React.createElement(exports.Border, null, props.children));
    }
    return React.createElement("div", { style: tileAreaStyle }, props.children);
};
exports.DashboardTile.displayName = 'DashboardTile';
